<template>
  <div class="invoice-products">
    <div
      class="invoice-products-head--title black--text font-weight-medium"
      :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }"
    >
      <DashboardBreadcrumb :items="breadCrumbItems" />
    </div>
    <v-card elevation="4" class="px-8 py-6 mt-4">
      <v-row
        class="loader fill-height py-6"
        align="center"
        justify="center"
        v-if="isInvoiceProductsFormLoading || retrievingEditExportJob"
      >
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-row>
      <div v-else>
        <div class="invoice-products-body mt-6 mb-6" :class="{ 'pa-5': xsOrsm, 'pa-6': breakpointMd, 'pa-8': xlOrlg }">
          <div class="invoice-products-body__header d-sm-flex align-center" :class="{ 'text-center': breakpointXs }">
            <div class="invoice-products-body__header--title fs-25 fw-600">
              Invoices
            </div>
            <v-spacer v-if="!breakpointXs"></v-spacer>
            <div class="invoice-products-body__header__search" :class="{ 'mt-3': breakpointXs, 'mr-4': !breakpointXs }">
              <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
            </div>
            <div class="invoice-products-body__header--button" :class="{ 'mt-3': breakpointXs }">
              <v-btn width="180" color="button-primary" large class="white--text" @click="handleAddNewInvoiceClick()">
                <v-icon left>fas fa-plus</v-icon>
                <span class="font-weight-bold fs-15">Add New</span>
              </v-btn>
            </div>
          </div>
          <div class="invoice-products-body__table mt-2">
            <v-data-table :items-per-page="5" :headers="tableHeaders" :items="invoices" :search="search">
              <template v-slot:item.edit="{ item }">
                <v-row>
                  <v-col cols="12" :xs="6" :sm="6" :md="6" :lg="6" class="text-right pr-1">
                    <v-btn
                      color="lightPrimary"
                      class="info font-weight-bold mx-2"
                      dense
                      @click="updateActionHandler(item)"
                      >Edit</v-btn
                    >
                  </v-col>
                </v-row>
              </template>
              <template v-slot:item.delete="{ item }">
                <v-row>
                  <v-col cols="12" :xs="6" :sm="6" :md="6" :lg="6" class="text-left pl-1">
                    <v-btn color="lightPrimary" class=" error font-weight-bold" dense @click="deleteActionHandler(item)"
                      >Delete</v-btn
                    >
                  </v-col>
                </v-row>
              </template>
              </v-data-table
            >
          </div>
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <div class="d-sm-flex justify-start" :class="{ 'text-center': breakpointXs }">
                <v-btn
                  width="140"
                  color="info"
                  large
                  class="white--text"
                  :loading="isInvoiceProductsFormLoading || savingExportJob"
                  @click="$router.push({ name: 'dashboard.export.consignee' })"
                >
                  <v-icon class="font-weight-bold fs-15 mr-2">fa fa-arrow-circle-left</v-icon>
                  <span class="font-weight-bold fs-15">Previous</span>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
                <v-btn
                  width="140"
                  color="button-primary"
                  large
                  class="white--text"
                  :loading="isInvoiceProductsFormLoading || savingExportJob"
                  @click="saveInvoiceProducts"
                >
                  <span class="font-weight-bold fs-15">Save</span>
                </v-btn>
                <div class="ml-2 mr-2 my-1"></div>
                <v-btn
                  width="140"
                  color="info"
                  large
                  class="white--text"
                  :loading="isInvoiceProductsFormLoading || savingExportJob"
                  @click="$router.push({ name: 'dashboard.export.freight-insurance' })"
                >
                  <span class="font-weight-bold fs-15">Next</span>
                  <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
    <ConfirmDeleteDialog
      @clicked-yes="deleteInvoice"
      @clicked-no="showConfirmationDialog = false"
      v-if="showConfirmationDialog"
    />
  </div>
</template>
<script>
import DashboardBreadcrumb from "@/modules/DashboardModule/components/DashboardBreadcrumb";
import ConfirmDeleteDialog from "@/modules/DashboardModule/components/ConfirmDeleteDialog";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "InvoiceProducts",
  components: {
    DashboardBreadcrumb,
    ConfirmDeleteDialog
  },
  data() {
    return {
      showConfirmationDialog: false,
      isInvoiceProductsFormLoading: false,
      search: "",
      storeDeleteInvoice: ""
    };
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    setInvoiceScreenBlank() {
      this.$store.commit(MT.SET_INVOICE_BLANK);
    },
    handleAddNewInvoiceClick() {
      this.setInvoiceScreenBlank();
      this.$store.commit(MT.SET_INVOICE_PRODUCTS_PAGE_PASSED);
      this.$router.push({ name: "dashboard.export.invoice-products.add-invoice" });
      return;
    },
    saveInvoiceProducts() {
      this.saveExportJob();
    },
    deleteActionHandler(invoice) {
      this.storeDeleteInvoice = invoice;

      this.showConfirmationDialog = true;
    },
    deleteInvoice() {
      const invoice = this.storeDeleteInvoice;
      this.$store.commit(MT.REMOVE_INVOICE_FROM_EXPORT_JOB, { srNo: invoice.invoiceSrNo });
      this.$store.commit(MT.REASSIGN_SRNO_TO_INVOICE_EXPORT_JOB, invoice.invoiceSrNo);
      this.$store.commit(MT.REMOVE_INVOICE_RELATED_FROM_EXPORT_JOB, { ...invoice });
      this.storeDeleteInvoice = null;
      this.showConfirmationDialog = false;
    },
    updateActionHandler(item) {
      this.setInvoiceScreenBlank();
      this.$store.commit(MT.SET_INVOICE_PRODUCTS_PAGE_PASSED);
      return this.$router.push({
        name: "dashboard.export.invoice-products.add-invoice",
        params: { invoiceSrNo: item.invoiceSrNo }
      });
    }
  },
  computed: {
    tableHeaders() {
      return [
        { text: "Sr No.", value: "invoiceSrNo", align: "center" },
        { text: "Invoice Name", value: "invoiceName", align: "center" },
        { text: "Invoice Date", value: "invoiceDate", align: "center" },
        { text: "Currency", value: "invoiceCurrencyCode", align: "center" },
        { text: "Exchange Rate", value: "exchangeRate", align: "center" },
        { text: "Terms of Invoice", value: "natureOfContract", align: "center" },
        { text: "Invoice Value", value: "invoiceValue", align: "center" },
        { text: "Edit", value: "edit", align: "center" },
        { text: "Delete", value: "delete", align: "center" }
      ];
    },
    invoices() {
      return this.$store.getters.exportJob.invoices;
    },
    breadCrumbItems() {
      return [
        {
          title: "Dashboard",
          route: "dashboard.home",
          children: [
            {
              title: "Export",
              route: "dashboard.export",
              children: [
                {
                  title: "Invoices & Products",
                  route: "dashboard.export.invoice-products"
                }
              ]
            }
          ]
        }
      ];
    }
  }
};
</script>
<style lang="scss">
@import "../../../../../../../styles/settings/index";

.invoice-products {
  .invoice-products-body {
    border: 2px solid $border-grey;
    border-radius: 10px;
    &__table {
      .v-data-table {
        background: transparent !important;
      }
    }
  }
}
</style>
